// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3oAqt","mainInfo":"styles_mainInfo__2kUTJ","virtualDeskInfo":"styles_virtualDeskInfo__lFSZa","buttonContainer":"styles_buttonContainer__3-nZI"};